<template>
  <router-link
    v-if="plato.tieneEnlace && plato.interno"
    :to="plato.href"
    class="nutricion-receta-link"
    draggable="false"
  >
    {{ plato.texto }}
    <i class="bi bi-journal-check ms-1" aria-hidden="true"></i>
  </router-link>
  <a
    v-else-if="plato.tieneEnlace"
    :href="plato.href"
    target="_blank"
    rel="noopener noreferrer"
    class="nutricion-receta-link"
    draggable="false"
  >
    {{ plato.texto }}
    <i class="bi bi-box-arrow-up-right ms-1" aria-hidden="true"></i>
  </a>
  <span v-else>{{ plato.texto || '—' }}</span>
</template>

<script>
import { computed } from 'vue';
import { platoConEnlace } from '@/utils/nutricionMenus';

export default {
  name: 'NutricionPlatoLink',
  props: {
    texto: { type: String, default: '' },
    href: { type: String, default: '' },
  },
  setup(props) {
    const plato = computed(() => platoConEnlace(props.texto, props.href));
    return { plato };
  },
};
</script>

<style scoped>
.nutricion-receta-link {
  color: var(--bs-primary, #0d6efd);
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-word;
}
.nutricion-receta-link:hover {
  color: var(--bs-link-hover-color, #0a58ca);
}
.nutricion-receta-link i {
  font-size: 0.75em;
}
</style>
